import { useMemo } from 'react';

import { useMyAccount, useMyStore, useQuery } from '../hooks';

import { DTCC_PROMOTION_PLANS } from '../../graphql/dtcc-queries';

import { CarCareOnePromotionData, Maybe } from '../../types/graphql-types';

export default function useDTCCFinancingPromotion(value) {
  const { myStore } = useMyStore();
  const { isFleetAccount } = useMyAccount();

  const { code: storeCode } = myStore || {};

  const valueAsNumber = typeof value === 'number' ? value : NaN;

  const { data: dtccPromoData } = useQuery(DTCC_PROMOTION_PLANS, {
    skip:
      isNaN(valueAsNumber) ||
      (process.env.__FF_FLEET_ACCOUNT__ === 'true' && isFleetAccount),
    variables: {
      storeCode
    }
  });

  function getPromoInPriceRange(
    price: number,
    promotions: Maybe<CarCareOnePromotionData>[]
  ) {
    return promotions.find(
      p => p?.minOrderAmount <= price && p?.maxOrderAmount >= price
    );
  }

  const promotionData = useMemo(
    () =>
      getPromoInPriceRange(
        valueAsNumber,
        dtccPromoData?.storeCheckout?.['allCC1PromotionPlans'] || []
      ),
    [dtccPromoData, valueAsNumber]
  );

  return {
    promotionData
  };
}
